var map = {
	"./adesivo.png": 1234,
	"./checkTexto.png": 553,
	"./iconeCaminhao.png": 1235,
	"./iconeCarro.png": 1236,
	"./iconeMoto.png": 1237,
	"./imgCard01.png": 1238,
	"./imgCard02.png": 1239,
	"./imgCard03.png": 1240,
	"./imgCard04.png": 1241,
	"./imgTituloPrincipal.png": 1242,
	"./pulseira.png": 1243,
	"./relogio.png": 1244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 232;